import { metaData } from '@cornerstonejs/core';
function getInstanceModule(imageId, metaDataProvider, types) {
    const result = {};
    for (const t of types) {
        try {
            const data = metaDataProvider(t, imageId);
            if (data) {
                const capitalizedData = {};
                for (const key in data) {
                    if (key in data) {
                        const capitalizedKey = metaData.toUpperCamelTag(key);
                        capitalizedData[capitalizedKey] = data[key];
                    }
                }
                Object.assign(result, capitalizedData);
            }
        }
        catch (error) {
            console.error(`Error retrieving ${t} data:`, error);
        }
    }
    return result;
}
const instanceModuleNames = [
    'multiframeModule',
    'generalSeriesModule',
    'patientStudyModule',
    'imagePixelModule',
    'modalityLutModule',
    'voiLutModule',
    'sopCommonModule',
    'petIsotopeModule',
    'overlayPlaneModule',
    'transferSyntax',
    'petSeriesModule',
    'petImageModule',
];
export { getInstanceModule, instanceModuleNames };
